import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import DAYS from './../../data/Days';
import ONDE_TREINA from './../../data/Onde_treina';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';
import TIPOS_PLANILHA from './../../data/TiposPlanilha';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

const URL_UPDATE = WS.alterar_senha.update;

export default class PageAcesso extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      senha: '',
      confirmar_senha: '',
      senha_atual: '',
      strings: STRINGS[window.LANGUAGE]
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {...this.state};

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    if(!data.senha ||
      !data.senha_atual ||
      !data.confirmar_senha){
      var msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };

      Dialog.create(msg);
      return false;
    }else{

      Requisitions({
        url:URL_UPDATE,
        data: data,
        sucess:function(data){
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }
  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <form className="form-login"  onSubmit={this.handleSubmit}>
          <TextInput
            type='password'
            value={this.state.nome}
            onChange={this.handleInputChange}
            name="senha"
            title={`${strings.txtSenha}*`}
            placeholder={strings.digiteAqui}>
          </TextInput>
          <TextInput
            type='password'
            value={this.state.email}
            onChange={this.handleInputChange}
            name="confirmar_senha"
            title={`${strings.txtConfirmarSenha}*`}
            placeholder={strings.digiteAqui}>
          </TextInput>
          <TextInput
            type='password'
            value={this.state.email}
            onChange={this.handleInputChange}
            name="senha_atual"
            title={`${strings.txtSenhaAntiga}*`}
            placeholder={strings.digiteAqui}>
          </TextInput>

          <Button text={strings.txtSalvar} onClick={this.handleSubmit} type='submit' classes="button-login simple-button" />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perfil/PageAcesso.js